import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import axios from 'axios';
import { Button, Offcanvas, OffcanvasBody, Row, Col } from 'reactstrap';
import { useLocation, useParams } from 'react-router-dom';
import LanguageDropdown from '../Languagedropdown';
import { useLanguage } from '../context/Languagecontext';
import { useTranslatedText } from '../../hooks/useTranslatedText';
import UploadModal from './uploadPopup';
import CompletePopup from './completepopup';
import NoInternet from '../NoInternet';
import NoDataFound2 from '../NoData2';
import Nouser from "../../img/NoUserFound.png";
import NoNet from "../../img/NoNet.png";
import NouserDark from "../../img/NoUserFoundDark.png";
import NoNetDark from "../../img/NoNetDark.png";
import RotatePhonePopup from '../RotatePhonePopup';
import { useSnackbar } from "../context/SnackbarContext";

import image1 from '../../img/cardbg1.png';
import image3 from '../../img/cardbg3.png';
import image4 from '../../img/cardbg4.png';

import annoycamera from "../../img/annoycamera.svg";
import placeholder from "../../img/placeholder.png";
import camera from "../../img/uploadcamera.svg"
import gallery from "../../img/uploadgallery.svg"

// ─── Default avatar URLs (same as Category3) ────────────────────────────────
const DEFAULT_AVATARS2 = [
    "https://lol-image-bucket.s3.amazonaws.com/images/Avatar/Avatar-ccd6af8c-cc2f-4910-824d-744c3fd248eb.png",
    "https://lol-image-bucket.s3.amazonaws.com/images/Avatar/Avatar-c2e51864-e332-4be9-a803-90f643ccd7ca.png",
    "https://lol-image-bucket.s3.amazonaws.com/images/Avatar/Avatar-a456ddbf-c0fd-4b6f-a585-22325e9e93a2.png",
    "https://lol-image-bucket.s3.amazonaws.com/images/Avatar/Avatar-0f0e5f82-af4e-4a52-9f33-4818a8ab21c8.png",
    "https://lol-image-bucket.s3.amazonaws.com/images/Avatar/Avatar-d9278bc7-acaf-40cc-8562-a1b666a713ab.png",
    "https://lol-image-bucket.s3.amazonaws.com/images/Avatar/Avatar-d89e6e8a-fb64-4443-bf1a-465039f28e70.png"
];

const AVATARS_PER_PAGE = 15;

const randomImages = [image1, image3, image4];

const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};

const DEFAULT_DATA = {
    CardBg: 'https://lol-image-bucket.s3.amazonaws.com/images/CardBg/UserCardBg-0e81fd73-54d9-43ca-a6c0-2328d596e894.jpg',
    shapeUrl: 'https://lol-image-bucket.s3.ap-south-1.amazonaws.com/shape2.png',
    fontName: 'Spider',
    shapeName: 'circle'
};

const isSmallScreen = window.innerWidth <= 375 && window.innerWidth !== 360;

// ─── SessionStorage helpers ──────────────────────────────────────────────────
const saveToSessionStorage = (key, value) => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { console.error(e); }
};
const getFromSessionStorage = (key) => {
    try { const item = sessionStorage.getItem(key); return item ? JSON.parse(item) : null; } catch { return null; }
};
const clearSessionStorage = (key) => {
    try { sessionStorage.removeItem(key); } catch (e) { console.error(e); }
};

// ─── Skeleton ────────────────────────────────────────────────────────────────
const CardSkeleton = ({ width }) => (
    <div className="shadow rounded-4 mx-auto p-0 py-2 d-flex flex-column gap-2 justify-content-between"
        style={{ width, minHeight: isSmallScreen ? "365px" : "520px" }}>
        <div className="mx-auto d-flex justify-content-center align-items-center"
            style={{ width: isSmallScreen ? "190px" : "220px", height: isSmallScreen ? "110px" : "130px" }}>
            <div className="shimmer-element rounded-3" style={{ width: "80%", height: "30px" }} />
        </div>
        <div className="my-1 mx-auto shimmer-element"
            style={{ borderRadius: "50%", width: isSmallScreen ? "130px" : "145px", height: isSmallScreen ? "130px" : "145px" }} />
        <div className="pt-2 d-flex justify-content-center align-items-center">
            <div className="shimmer-light d-flex flex-column gap-2 p-3"
                style={{ minHeight: "155px", width: "95%", borderRadius: "10px" }}>
                {[1, 2, 3, 4].map(item => (
                    <div key={item} className="d-flex gap-2 align-items-center">
                        <div className="rounded" style={{ width: "45%", height: "18px" }} />
                        <div className="rounded" style={{ width: "5%", height: "18px" }} />
                        <div className="rounded" style={{ width: "45%", height: "18px" }} />
                    </div>
                ))}
            </div>
        </div>
    </div>
);

const getInitialDarkMode = () =>
    typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)').matches : false;

const TranslatedQuestion = ({ text, lanText }) => {
    const translated = useTranslatedText(text, lanText);
    return <>{translated}</>;
};
const EditFieldLabel = ({ text, lanText }) => {
    const translated = useTranslatedText(text, lanText);
    return <>{translated}</>;
};


// ─── Avatar Bottom Sheet ─────────────────────────────────────────────────────
const AvatarBottomSheet = ({ isOpen, onClose, currentAvatar, onAvatarChange, t }) => {
    const [imageUrls, setImageUrls] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const [imageLoadingStates, setImageLoadingStates] = useState({});
    const [isCheckingConnection, setIsCheckingConnection] = useState(false);
    const [selectedUrl, setSelectedUrl] = useState(currentAvatar || null);
    const [showUploadModal, setShowUploadModal] = useState(false);

    const scrollContainerRef = useRef(null);
    const loadingRef = useRef(false);
    const loadingMoreRef = useRef(false);
    const currentPageRef = useRef(1);
    const iosFileInputRef = useRef(null);
    const { showSnackbar } = useSnackbar();
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // ─── Cache helpers (same pattern as Category3) ───────────────────────────
    const CACHE_NAME = 'lol-image-cache-v1';
    const CACHE_EXPIRY_KEY = 'image-cache-expiry';
    const CACHE_DURATION = 7 * 24 * 60 * 60 * 1000;

    const getCachedImage = async (url) => {
        try {
            const expiryTime = localStorage.getItem(`${CACHE_EXPIRY_KEY}-${url}`);
            if (expiryTime && Date.now() > parseInt(expiryTime)) return null;
            const cache = await caches.open(CACHE_NAME);
            const response = await cache.match(url);
            if (response) { const blob = await response.blob(); return URL.createObjectURL(blob); }
            return null;
        } catch { return null; }
    };

    const cacheImage = async (url, blob) => {
        try {
            const cache = await caches.open(CACHE_NAME);
            await cache.put(url, new Response(blob));
            localStorage.setItem(`${CACHE_EXPIRY_KEY}-${url}`, (Date.now() + CACHE_DURATION).toString());
        } catch { /* silent */ }
    };

    // ─── Internet check ───────────────────────────────────────────────────────
    const checkInternetConnection = async () => {
        await new Promise(resolve => setTimeout(resolve, 700));
        if (!navigator.onLine) return false;
        try { return true; } catch { return false; }
    };

    // ─── Image compression (same as Category3) ────────────────────────────────
    const compressImage = (file) => new Promise((resolve, reject) => {
        if (file.type === 'image/gif') { resolve(file); return; }
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = document.createElement('img');
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let { width, height } = img;
                const MAX = 1200;
                if (width > height) { if (width > MAX) { height = Math.round(height * MAX / width); width = MAX; } }
                else { if (height > MAX) { width = Math.round(width * MAX / height); height = MAX; } }
                canvas.width = width; canvas.height = height;
                canvas.getContext('2d').drawImage(img, 0, 0, width, height);
                canvas.toBlob(blob => {
                    if (!blob) { reject(new Error('Blob failed')); return; }
                    resolve(new File([blob], file.name, { type: file.type, lastModified: Date.now() }));
                }, file.type, 0.7);
            };
            img.onerror = () => reject(new Error('Image load failed'));
            img.src = event.target.result;
        };
        reader.onerror = () => reject(new Error('Read failed'));
        reader.readAsDataURL(file);
    });

    // ─── Fetch avatars ────────────────────────────────────────────────────────
    const getImages = useCallback(async (page = 1, append = false) => {
        if (loadingRef.current || loadingMoreRef.current) return;
        if (append) { loadingMoreRef.current = true; setLoadingMore(true); }
        else { loadingRef.current = true; setLoading(true); }

        const timeoutPromise = new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 8000));

        try {
            const fetchPromise = axios.post('https://api.lolcards.link/api/avatar/read', { page, limit: AVATARS_PER_PAGE }, { timeout: 6000 });
            const { data } = await Promise.race([fetchPromise, timeoutPromise]);
            const images = data?.data || [];
            if (!images.length) throw new Error('No images');
            setHasMore(data?.hasMore || false);
            const newStates = {};
            images.forEach(url => { newStates[url] = false; });
            setImageLoadingStates(prev => ({ ...prev, ...newStates }));
            if (append) setImageUrls(prev => [...prev, ...images]);
            else setImageUrls(images);
        } catch {
            if (!append) {
                const shuffled = [...DEFAULT_AVATARS2].sort(() => 0.5 - Math.random()).slice(0, 6);
                const newStates = {};
                shuffled.forEach(url => { newStates[url] = false; });
                setImageLoadingStates(newStates);
                const cached = await Promise.all(shuffled.map(async (url) => {
                    try {
                        const c = await getCachedImage(url);
                        if (c) return c;
                        const res = await fetch(url);
                        const blob = await res.blob();
                        await cacheImage(url, blob);
                        return URL.createObjectURL(blob);
                    } catch { return url; }
                }));
                setImageUrls(cached);
            }
        } finally {
            loadingRef.current = false;
            loadingMoreRef.current = false;
            setLoading(false);
            setLoadingMore(false);
        }
    }, []);

    // ─── Infinite scroll ──────────────────────────────────────────────────────
    const handleScroll = useCallback(() => {
        if (!scrollContainerRef.current || loadingMoreRef.current || !hasMore) return;
        const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
        if (scrollTop + clientHeight >= scrollHeight * 0.8) {
            currentPageRef.current += 1;
            setLoadingMore(true);
            getImages(currentPageRef.current, true);
        }
    }, [hasMore, getImages]);

    useEffect(() => {
        if (isOpen) {
            currentPageRef.current = 1;
            setSelectedUrl(currentAvatar || null);
            getImages(1, false);
        }
    }, [isOpen]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;
        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [handleScroll, isOpen]);

    // ─── iOS file pick ────────────────────────────────────────────────────────
    const handleIOSFileChange = async (e) => {
        const file = e.target.files[0];
        e.target.value = '';
        if (!file) return;
        try {
            const compressed = await compressImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                const dataUrl = reader.result;
                setSelectedUrl(dataUrl);
                onAvatarChange(dataUrl);
            };
            reader.readAsDataURL(compressed);
        } catch (err) { console.error(err); }
    };

    const handleCameraClick = async () => {
        setIsCheckingConnection(true);
        const online = await checkInternetConnection();
        setIsCheckingConnection(false);
        if (!online) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection", "error");
            return;
        }
        if (isIOS && iosFileInputRef.current) {
            iosFileInputRef.current.click();
        } else {
            // Android/desktop: open UploadModal like Category3
            setShowUploadModal(true);
        }
    };

    const handleAvatarSelect = (url) => {
        setSelectedUrl(url);
        onAvatarChange(url);
    };

    const handleImageLoad = (url) => {
        setImageLoadingStates(prev => ({ ...prev, [url]: true }));
    };

    return (
        <>
            {/* Hidden iOS file input */}
            {isIOS && (
                <input
                    ref={iosFileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleIOSFileChange}
                    style={{ display: 'none' }}
                />
            )}

            {!isIOS && (
                <UploadModal
                    show={showUploadModal}
                    onClose={() => setShowUploadModal(false)}
                    onImageSelect={(imageData) => {
                        setSelectedUrl(imageData);
                        onAvatarChange(imageData);
                        setShowUploadModal(false);
                    }}
                    onProcessing={() => { }}
                    onError={(msg) => showSnackbar(msg, "error")}
                    t={t}
                    camera={camera}
                    gallery={gallery}
                    detect={false}
                />
            )}

            <Offcanvas
                isOpen={isOpen}
                toggle={onClose}
                direction="bottom"
                style={{
                    borderRadius: "24px 24px 0 0",
                    height: "50vh",
                    overflow: "hidden",
                }}
            >

                <OffcanvasBody
                    className="px-0 pt-2 pb-3 position-relative"
                    style={{
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >                    {/* Scrollable grid */}
                    <div
                        ref={scrollContainerRef}
                        className="overflow-y-auto rounded-4 p-2"
                        style={{ flex: 1 }}
                    >
                        <Row className="w-100 g-2 mx-0">
                            {/* ── Camera / Upload tile (always first) ── */}
                            <Col xs={3}>
                                <div
                                    className="rounded-4 d-flex flex-column align-items-center justify-content-center"
                                    style={{
                                        width: "100%",
                                        aspectRatio: "1/1",
                                        background: "#FFEBEA",
                                        cursor: isCheckingConnection ? "not-allowed" : "pointer",
                                        border: "2px dashed #FF827C",
                                    }}
                                    onClick={handleCameraClick}
                                >
                                    {isCheckingConnection ? (
                                        <div className="custom-spinner" style={{ borderTopColor: "#FF207B" }} />
                                    ) : (
                                        <>
                                            <img src={annoycamera} alt="camera" width={35} />
                                            <p className="m-0 pt-2 text-center GTRegular"
                                                style={{
                                                    lineHeight: "13px",
                                                    fontSize: "clamp(11px, 2vw, 14px)",
                                                    wordBreak: "normal",
                                                    overflowWrap: "break-word",
                                                }}>
                                                {t?.annoyCard?.addFace || "Add Face"}
                                            </p>
                                        </>
                                    )}
                                </div>
                            </Col>

                            {/* ── Avatar tiles ── */}
                            {loading
                                ? Array.from({ length: AVATARS_PER_PAGE }).map((_, i) => (
                                    <Col xs={3} key={`skel-${i}`}>
                                        <div className="rounded-4" style={{
                                            width: "100%", aspectRatio: "1/1",
                                            background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
                                            backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite"
                                        }} />
                                    </Col>
                                ))
                                : imageUrls.map((url, i) => (
                                    <Col xs={3} key={url || i}>
                                        <div
                                            className="rounded-4 overflow-hidden position-relative"
                                            style={{
                                                width: "100%", aspectRatio: "1/1", cursor: "pointer",
                                                background: "#FFEBEA",
                                                border: selectedUrl === url ? "2.5px solid #000" : "2.5px solid transparent",
                                            }}
                                            onClick={() => handleAvatarSelect(url)}
                                        >
                                            {!imageLoadingStates[url] && (
                                                <div className="position-absolute top-0 start-0 w-100 h-100 rounded-4 d-flex align-items-center justify-content-center"
                                                    style={{ background: "#f0f0f0", zIndex: 1 }}>
                                                    <img src={placeholder} alt="placeholder"
                                                        style={{ width: "50%", height: "50%", objectFit: "cover" }} />
                                                </div>
                                            )}
                                            <img
                                                src={url || placeholder}
                                                alt="avatar"
                                                onLoad={() => handleImageLoad(url)}
                                                onError={(e) => { e.target.src = placeholder; handleImageLoad(url); }}
                                                style={{
                                                    width: "100%", height: "100%", objectFit: "cover",
                                                    opacity: imageLoadingStates[url] ? 1 : 0,
                                                    transition: "opacity 0.3s",
                                                }}
                                            />
                                        </div>
                                    </Col>
                                ))
                            }

                            {/* Load more skeleton row */}
                            {loadingMore && Array.from({ length: 3 }).map((_, i) => (
                                <Col xs={3} key={`more-skel-${i}`}>
                                    <div className="rounded-4" style={{
                                        width: "100%", aspectRatio: "1/1",
                                        background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
                                        backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite"
                                    }} />
                                </Col>
                            ))}
                        </Row>


                        {/* ========== fade ============== */}
                        <div
                            style={{
                                position: "absolute",
                                top: "0px", // adjust based on header
                                left: 0,
                                width: "100%",
                                height: "60px",
                                pointerEvents: "none",
                                zIndex: 10,
                                background: "linear-gradient(to bottom, white 30%, transparent)"
                            }}
                        />

                        <div
                            style={{
                                position: "absolute",
                                bottom: "80px", // above button
                                left: 0,
                                width: "100%",
                                height: "60px",
                                pointerEvents: "none",
                                zIndex: 10,
                                background: "linear-gradient(to top, white 20%, transparent)"
                            }}
                        />
                    </div>

                    {/* ── Confirm button ── */}
                    <Button
                        className="rounded-pill GTMedium text-white border-0 mt-3 mx-auto d-block"
                        style={{
                            width: "min(350px, 65%)",
                            height: "50px",
                            background: selectedUrl ? "#000" : "#ccc",
                            cursor: selectedUrl ? "pointer" : "not-allowed",
                            fontSize: "clamp(18px, 4vw, 22px)",
                        }}
                        disabled={!selectedUrl || isCheckingConnection}
                        onClick={onClose}
                    >
                        {t?.common?.done || "Done"}
                    </Button>
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
};

// ─── Main ShowCard Component ─────────────────────────────────────────────────
const ShowCard = () => {
    const location = useLocation();
    const { lanText, t } = useLanguage();
    const { username, category } = useParams();

    const getStateData = () => {
        if (location.state && location.state.nickname !== undefined) return location.state;
        return getFromSessionStorage('showCardState') || {};
    };

    const stateData = getStateData();
    const { hint, uploadedImage, originalData, avatar: initialAvatar, nickname: initialNickname, annoyans: initialAnnoyans } = stateData;

    const backgroundImage = useMemo(() => {
        const randomIndex = Math.floor(Math.random() * randomImages.length);
        return randomImages[randomIndex];
    }, []);

    const urlParams = new URLSearchParams(window.location.search);
    const shouldShowModal = urlParams.get("success") === "1";

    const [isInputFocused, setIsInputFocused] = useState(false);
    const [loading, setLoading] = useState(!shouldShowModal);
    const [randomData, setRandomData] = useState(shouldShowModal ? DEFAULT_DATA : null);
    const [imageLoaded, setImageLoaded] = useState(shouldShowModal);
    const [isUploading, setIsUploading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(shouldShowModal);
    const [noInternet, setNoInternet] = useState(false);
    const [noNetDarkImgSrc, setNoNetDarkImgSrc] = useState(null);
    const [isDarkMode, setIsDarkMode] = useState(getInitialDarkMode);
    const [noNetImgSrc, setNoNetImgSrc] = useState(null);
    const [noNetImgLoaded, setNoNetImgLoaded] = useState(false);
    const [noUserDarkImgSrc, setNoUserDarkImgSrc] = useState(null);
    const [noUserImgLoaded, setNoUserImgLoaded] = useState(false);
    const [noUserImgSrc, setNoUserImgSrc] = useState(null);
    const [isCheckingConnection, setIsCheckingConnection] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const { showSnackbar } = useSnackbar();
    const [error, setError] = useState(false);

    // ─── Avatar bottom sheet state ────────────────────────────────────────────
    const [avatarSheetOpen, setAvatarSheetOpen] = useState(false);
    const [localAvatar, setLocalAvatar] = useState(initialAvatar || null);

    // ─── Local editable state ─────────────────────────────────────────────────
    const [localNickname, setLocalNickname] = useState(initialNickname || '');
    const [localAnnoyans, setLocalAnnoyans] = useState(initialAnnoyans || []);

    // ─── Edit mode temp state ─────────────────────────────────────────────────
    const [editNickname, setEditNickname] = useState('');
    const [editAnswers, setEditAnswers] = useState([]);
    const [shakingField, setShakingField] = useState(null);

    const EDIT_CHAR_LIMITS = { nickname: 10, answer: 15 };

    const triggerFieldShake = (fieldKey) => {
        setShakingField(fieldKey);
        setTimeout(() => setShakingField(null), 600);
    };

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const cardWidth = () => window.innerWidth <= 375 ? '95%' : '360px';

    const data = originalData?.question;
    const questionText = Array.isArray(data)
        ? data.find(item => item.category === category)?.question || t?.defaultQuestion
        : t?.defaultQuestion;

    const translatedQuestion = useTranslatedText(questionText, lanText);

    const checkInternetConnection = async () => {
        await new Promise(resolve => setTimeout(resolve, 500));
        if (!navigator.onLine) return false;
        try { return true; } catch { return false; }
    };

    useEffect(() => {
        const checkDarkMode = () => {
            const mq = window.matchMedia('(prefers-color-scheme: dark)');
            setIsDarkMode(mq.matches);
        };
        checkDarkMode();
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e) => setIsDarkMode(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    const currentNoUserImg = isDarkMode ? noUserDarkImgSrc : noUserImgSrc;
    const currentNoNetImg = isDarkMode ? noNetDarkImgSrc : noNetImgSrc;

    // Load images from localStorage (written by CategoryLink)
    useEffect(() => {
        let isMounted = true;

        const loadImage = (key, fallbackImg, setter, setLoaded) => {
            const cached = localStorage.getItem(key);
            if (isMounted) {
                setter(cached || fallbackImg);
                if (setLoaded) setLoaded(true);
            }
        };

        loadImage('noUserImage', Nouser, setNoUserImgSrc, setNoUserImgLoaded);
        loadImage('noNetImage', NoNet, setNoNetImgSrc, setNoNetImgLoaded);
        loadImage('noUserImageDark', NouserDark, setNoUserDarkImgSrc);
        loadImage('noNetImageDark', NoNetDark, setNoNetDarkImgSrc);

        return () => { isMounted = false; };
    }, []);

    useEffect(() => {
        if (location.state && location.state.nickname !== undefined) {
            saveToSessionStorage('showCardState', location.state);
        }
    }, [location.state]);

    const preloadImage = (url) => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = reject;
        img.src = url;
    });

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get("success") === "1" || randomData) return;
        if (!navigator.onLine) { setNoInternet(true); return; }
        setLoading(true);
        setImageLoaded(false);
        axios.post('https://api.lolcards.link/api/web/cardpreview')
            .then(({ data }) => {
                setRandomData(data.data);
                setError(false);
                return preloadImage(data.data.CardBg);
            })
            .then(() => { setImageLoaded(true); setLoading(false); })
            .catch(() => { setError(true); setImageLoaded(true); setLoading(false); });
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            if (showSuccessModal) {
                setShowSuccessModal(false);
                const url = new URL(window.location.href);
                if (url.searchParams.has("success")) {
                    url.searchParams.delete("success");
                    window.history.replaceState({}, "", url.pathname);
                }
            }
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [showSuccessModal]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get("success") === "1") setShowSuccessModal(true);
    }, []);

    useEffect(() => {
        const handleFocusIn = (e) => { if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") setIsInputFocused(true); };
        const handleFocusOut = () => { setIsInputFocused(false); setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100); };
        window.addEventListener("focusin", handleFocusIn);
        window.addEventListener("focusout", handleFocusOut);
        return () => { window.removeEventListener("focusin", handleFocusIn); window.removeEventListener("focusout", handleFocusOut); };
    }, []);

    useEffect(() => {
        const isDisabled = isUploading || isCheckingConnection || avatarSheetOpen;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isUploading, isCheckingConnection, avatarSheetOpen]);

    // ─── Avatar change handler ────────────────────────────────────────────────
    const handleAvatarChange = (newAvatar) => {
        setLocalAvatar(newAvatar);
        // Sync back to sessionStorage
        const currentState = getFromSessionStorage('showCardState') || {};
        saveToSessionStorage('showCardState', { ...currentState, avatar: newAvatar });
    };

    // ─── Edit toggle ──────────────────────────────────────────────────────────
    const handleEditToggle = () => {
        if (!isEdit) {
            setEditNickname(localNickname || '');
            setEditAnswers((localAnnoyans || []).map(item => item.answer || ''));
            setIsEdit(true);
        } else {
            const finalNickname = (editNickname || '').trim() || localNickname;
            const finalAnswers = (localAnnoyans || []).map((item, i) => {
                const edited = (editAnswers[i] || '').trim();
                return edited !== '' ? edited : (item.answer || '');
            });
            const updatedAnnoyans = (localAnnoyans || []).map((item, i) => ({ ...item, answer: finalAnswers[i] }));
            setLocalNickname(finalNickname);
            setLocalAnnoyans(updatedAnnoyans);
            setIsEdit(false);

            const existingStepAnnoyans = (() => { try { return JSON.parse(sessionStorage.getItem('steppage_annoyans')) || {}; } catch { return {}; } })();
            const updatedStepAnnoyans = { ...existingStepAnnoyans };
            updatedStepAnnoyans[0] = finalNickname;
            updatedAnnoyans.forEach((item, i) => { updatedStepAnnoyans[i + 1] = item.answer; });
            sessionStorage.setItem('steppage_annoyans', JSON.stringify(updatedStepAnnoyans));

            const currentState = (() => { try { return JSON.parse(sessionStorage.getItem('showCardState')) || {}; } catch { return {}; } })();
            saveToSessionStorage('showCardState', { ...currentState, nickname: finalNickname, annoyans: updatedAnnoyans });
        }
    };

    const base64ToFile = (base64String, fileName) => {
        const arr = base64String.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) u8arr[n] = bstr.charCodeAt(n);
        return new File([u8arr], fileName, { type: mime });
    };

    const upload = async () => {
        const deviceIp = localStorage.getItem("deviceIp");
        setIsUploading(true);
        try {
            const formData = new FormData();
            const questions = (localAnnoyans || []).map(item => item.question);
            const answers = (localAnnoyans || []).map(item => item.answer);

            formData.append('id', originalData.id);
            formData.append('category', category);
            formData.append("webCategory", category);
            formData.append('hint', hint);
            if (uploadedImage) {
                if (uploadedImage.startsWith('data:image')) formData.append('uploadedImage', base64ToFile(uploadedImage, 'hintImage.jpg'));
                else formData.append('uploadedImage', uploadedImage);
            }
            formData.append('userLocation', "allow");
            formData.append('deviceIp', deviceIp);

            // Use localAvatar (potentially updated via bottom sheet)
            const avatarToUpload = localAvatar;
            console.log(localAvatar);

            if (avatarToUpload) {
                if (avatarToUpload.startsWith('data:image')) formData.append('annoyimage', base64ToFile(avatarToUpload, 'avatar.jpg'));
                else formData.append('annoyimage', avatarToUpload);
            }

            formData.append('shapename', randomData.shapeName);
            formData.append('nickname', localNickname);
            formData.append('shapeUrl', randomData.shapeUrl);
            formData.append('fontname', randomData.fontName);
            const translatedQuestions = originalData.annoycardvalue;
            formData.append('annoycardtitle', JSON.stringify(translatedQuestions));
            formData.append('annoyans', JSON.stringify(answers));
            formData.append('cardBg', randomData.CardBg);

            await axios.post('https://api.lolcards.link/api/newinbox/create', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            const url = new URL(window.location.href);
            url.searchParams.set('success', '1');
            window.history.pushState({ success: true }, '', url.toString());
            setShowSuccessModal(true);
        } catch (error) {
            console.error('Upload error:', error);
            showSnackbar(t?.common?.apiFail || 'Request failed. Please try again after some time!', "error");
        } finally {
            setIsUploading(false);
        }
    };

    const handleSendClick = async () => {
        if (localAnnoyans && !isUploading) {
            setIsCheckingConnection(true);
            const isOnline = await checkInternetConnection();
            setIsCheckingConnection(false);
            if (!isOnline) { showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error"); return; }
            try {
                await upload();
                await axios.patch('https://api.lolcards.link/api/admin/monitoring', { categoryname: category, id: originalData.id });
            } catch (err) { console.error('Monitoring error:', err); }
        }
    };

    const handleModalClose = () => {
        setShowSuccessModal(false);
        clearSessionStorage('showCardState');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.target.blur();
        }
    };

    if (noInternet) return <NoInternet style={{ height: '100vh' }} t={t.noData} Nouser={currentNoNetImg} imgLoaded={noNetImgLoaded} />;
    if (error) return <NoDataFound2 style={{ height: '100vh' }} t={t.noData2} Nouser={currentNoUserImg} username={username} category={category} imgLoaded={noUserImgLoaded} />;

    // ─── Avatar badge — pencil icon that opens bottom sheet ─────────────────
    const AvatarEditBadge = () => (
        <div
            onClick={() => { if (!isUploading && !isCheckingConnection) setAvatarSheetOpen(true); }}
            style={{
                position: "absolute",
                bottom: "2px",
                right: "2px",
                width: "30px",
                height: "30px",
                background: "#ffffff",
                borderRadius: "50%",
                border: "1.5px solid #353435",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                cursor: isUploading || isCheckingConnection ? "not-allowed" : "pointer",
                zIndex: 5,
            }}
        >
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.48091 2.61446C9.98314 2.07033 10.2343 1.79827 10.5011 1.63957C11.1449 1.25665 11.9377 1.24474 12.5924 1.60816C12.8636 1.75877 13.1224 2.02318 13.6401 2.55199C14.1578 3.08081 14.4166 3.34521 14.564 3.62235C14.9198 4.29104 14.9081 5.10092 14.5333 5.75864C14.3779 6.03123 14.1116 6.28775 13.579 6.80078L7.24128 12.905C6.23188 13.8773 5.72717 14.3634 5.09638 14.6097C4.4656 14.8561 3.77215 14.838 2.38526 14.8017L2.19656 14.7968C1.77435 14.7858 1.56324 14.7802 1.44052 14.6409C1.3178 14.5017 1.33456 14.2866 1.36807 13.8566L1.38626 13.623C1.48057 12.4125 1.52772 11.8073 1.7641 11.2632C2.00048 10.7191 2.40823 10.2774 3.22371 9.39383L9.48091 2.61446Z" stroke="black" strokeWidth="1.36722" strokeLinejoin="round" />
                <path d="M8.76562 2.6875L13.4833 7.4052" stroke="black" strokeWidth="1.36722" strokeLinejoin="round" />
                <path d="M9.4375 14.8203H14.8292" stroke="black" strokeWidth="1.36722" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );

    return (
        <div
            style={{
                height : "100dvh",
                backgroundColor: loading || !imageLoaded ? (isDarkMode ? "#1a1a1a" : "#ffffff") : undefined,
                backgroundImage: !loading && imageLoaded ? `url(${randomData.CardBg})` : "none",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Blur overlay */}
            <div style={{
                position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
                background: loading || !imageLoaded
                    ? (isDarkMode ? "rgba(26,26,26,0.95)" : "rgba(255,255,255,0.95)")
                    : "rgba(0,0,0,0.15)",
                backdropFilter: "blur(11px)", WebkitBackdropFilter: "blur(11px)", zIndex: 1,
            }} />

            <div className="h-100 pt-2" style={{ position: "relative", zIndex: 2 }}>
                <div
                    className={`mx-auto justify-content-evenly h-100`}
                    style={{ width: "550px", maxWidth: "95vw", display: "flex", flexDirection: "column" }}
                >
                    {/* ── Edit mode title ── */}
                    {isEdit && (
                        <div className="d-flex justify-content-center align-items-center mb-2 pt-42" style={{ height: '80px' }}>
                            <div className="text-center" style={{ maxWidth: "75vw" }}>
                                <p className="lh-sm mx-auto ps-2 m-0 pt-3"
                                    style={{
                                        fontSize: "clamp(15px, 4.5vw, 17px)", color: "#fff",
                                        display: "-webkit-box", WebkitLineClamp: 3,
                                        WebkitBoxOrient: "vertical", overflow: "hidden"
                                    }}>
                                    {t?.annoyCard?.editTitle || "Edit Your Card"}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* ════════════════════════════
                        PREVIEW (isEdit = false)
                    ════════════════════════════ */}
                    {!isEdit && (
                        <div className={`text-center d-flex flex-column align-items-center justify-content-center flex-grow-1 ${isIOS ? "mt-2" : "mt-5"}`}>
                            {loading || !imageLoaded ? (
                                <CardSkeleton width={cardWidth()} />
                            ) : randomData ? (
                                <div
                                    className={`shadow position-relative overflow-hidden rounded-4 mx-auto p-0 py-2 d-flex flex-column gap-2 justify-content-between ${showSuccessModal ? "" : "card-enter"}`}
                                    id="captureDiv"
                                    style={{
                                        border: "3px solid black", width: cardWidth(),
                                        minHeight: isSmallScreen ? "365px" : "500px",
                                        backgroundImage: `url(${randomData.CardBg})`,
                                        backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center",
                                    }}
                                >
                                    {/* Nickname shape */}
                                    <div className="mx-auto d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "280px", height: isSmallScreen ? "90px" : "120px",
                                            backgroundImage: `url(${randomData.shapeUrl})`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: isSmallScreen ? "280px 100px" : "280px 120px",
                                            backgroundPosition: "center",
                                        }}>
                                        <p className='bricolage-grotesque'
                                            style={{
                                                width: "65%", fontSize: "14px", lineHeight: "14px",
                                                display: "-webkit-box", WebkitLineClamp: 3,
                                                WebkitBoxOrient: "vertical", overflow: "hidden", paddingTop: "19px",
                                            }}>
                                            {t?.common?.que || 'Que:'}{' '}{translatedQuestion}
                                        </p>
                                    </div>

                                    {/* Avatar — pencil badge opens bottom sheet */}
                                    <div
                                        className="circle my-1 mb-3 mx-auto position-relative d-flex justify-content-center align-items-center bg-white"
                                        style={{
                                            border: "3px solid #353435",
                                            width: isSmallScreen ? "100px" : "135px",
                                            height: isSmallScreen ? "100px" : "135px",
                                        }}
                                    >
                                        <div style={{ width: "100%", height: "100%", overflow: "hidden", borderRadius: "inherit" }}>
                                            <div style={{
                                                width: "100%", height: "100%",
                                                backgroundImage: `url(${localAvatar})`,
                                                backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat",
                                            }} />
                                        </div>
                                        {/* Pencil badge — click opens avatar sheet */}
                                        <AvatarEditBadge />
                                    </div>

                                    {/* Answers table */}
                                    <div className="pt-2 d-flex justify-content-center align-items-center gilroy-heavy position-relative" style={{ fontWeight: "900" }}>
                                        <div className="d-flex justify-content-center align-items-center overflow-hidden"
                                            style={{
                                                background: "#fff", minHeight: isSmallScreen ? "145px" : "165px",
                                                width: "95%", borderRadius: "10px", border: "2px solid #363435",
                                            }}>
                                            <div className="d-flex justify-content-center align-items-center overflow-hidden pt-4 pb-1"
                                                style={{
                                                    minHeight: isSmallScreen ? "145px" : "165px", width: "100%",
                                                    backgroundImage: `url(${backgroundImage})`,
                                                    backgroundSize: "cover", backgroundPosition: "center", borderRadius: "10px",
                                                }}>
                                                <table className="table table-borderless mb-0" style={{ fontSize: "16px", width: "94%" }}>
                                                    <tbody>
                                                        {(localAnnoyans || []).map((value, index) => {
                                                            const isLast = index === (localAnnoyans || []).length - 1;
                                                            const rowClass = isLast ? "p-0" : "p-0 pb-2";
                                                            return (
                                                                <tr key={index}>
                                                                    <td className={`text-center bricolage-grotesque pe-1 ${rowClass}`}
                                                                        style={{
                                                                            width: "52%", color: "#373435", verticalAlign: "middle",
                                                                            background: "transparent", wordBreak: "break-word",
                                                                            fontSize: "clamp(14px, 3.5vw, 18px)", lineHeight: "1.2",
                                                                        }}>
                                                                        <TranslatedQuestion text={value.question} lanText={lanText} />
                                                                    </td>
                                                                    <td className={`text-center bricolage-grotesque ${rowClass}`}
                                                                        style={{ width: "1%", color: "#373435", background: "transparent", verticalAlign: "middle" }}>:</td>
                                                                    <td className={`text-center ps-2 bricolage-grotesque ${rowClass}`}
                                                                        style={{
                                                                            width: "47%", color: "#373435", verticalAlign: "middle",
                                                                            background: "transparent", wordBreak: "break-word",
                                                                            fontSize: "clamp(14px, 3.5vw, 18px)",
                                                                        }}>
                                                                        {capitalizeFirstLetter(value.answer)}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Nickname badge */}
                                        <div className="position-absolute" style={{ top: "-10px", left: "50%", transform: "translateX(-50%)", display: "inline-block" }}>
                                            <div className="position-relative d-inline-flex align-items-center justify-content-center px-4"
                                                style={{ fontWeight: "700", fontSize: "18px", height: "40px", minWidth: "150px", whiteSpace: "nowrap" }}>
                                                <svg viewBox="0 0 142 37" preserveAspectRatio="none"
                                                    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 0 }} fill="none">
                                                    <path d="M142 18.4995L138.86 19.4743C137.268 19.9683 136.14 22.3243 134.833 25.0488C133.606 27.6083 132.215 30.51 130.029 32.8306C127.638 35.3689 124.744 36.7245 121.204 36.9613V36.9955H120.42C120.302 36.9982 120.18 37 120.057 37V36.9955H21.9425V37C21.8236 37 21.7053 37 21.5877 36.9955H21.5697C17.6755 36.9137 14.5341 35.5515 11.9722 32.8306C9.78589 30.51 8.3952 27.6083 7.16815 25.0488C5.86127 22.323 4.73327 19.9686 3.1411 19.4749L0 18.4995L3.1395 17.5247C4.73183 17.031 5.85958 14.6747 7.16621 11.9505C8.39376 9.39171 9.78302 6.49 11.9708 4.16938C14.5343 1.44874 17.6752 0.0863304 21.5711 0.00451705C21.6926 0.00177223 21.8169 1.1573e-06 21.9427 1.1573e-06H120.057C120.182 1.1573e-06 120.307 1.37871e-06 120.43 0.00451705C124.324 0.0863304 127.466 1.44847 130.027 4.16938C132.216 6.49 133.606 9.39171 134.833 11.9535C136.14 14.6792 137.268 17.0335 138.86 17.5274L142 18.4995Z" fill="white" />
                                                    <path d="M138.86 17.5269C137.268 17.0332 136.14 14.6769 134.833 11.953C133.606 9.3934 132.215 6.49177 130.029 4.17115C127.467 1.45042 124.325 0.0881003 120.432 0.00628693C120.308 0.00354211 120.184 0.00177104 120.059 0.00177104H21.9425C21.8166 0.00177104 21.6925 0.00177126 21.5707 0.00628693C17.6748 0.0881003 14.5353 1.45042 11.9703 4.17115C9.78327 6.49177 8.39376 9.3934 7.16621 11.9553C5.85966 14.682 4.73183 17.0357 3.13975 17.5297L0 18.5012L3.13975 19.4749C4.73183 19.9687 5.85966 22.3248 7.16671 25.0487C8.39376 27.6086 9.78429 30.5102 11.9708 32.8306C14.5344 35.5515 17.6752 36.9137 21.568 36.9957H21.586C21.7037 36.9982 21.8219 37 21.9408 37V36.9957H120.057V37C120.179 37 120.301 37 120.42 36.9957H121.204V36.9613C124.745 36.7244 127.638 35.3681 130.029 32.8306C132.216 30.5102 133.606 27.6086 134.834 25.0487C136.14 22.3223 137.268 19.9682 138.86 19.4743L142 18.4995L138.86 17.5269ZM133.321 24.0679C130.907 29.1057 128.171 34.8154 120.401 34.9815H21.5983C13.831 34.8154 11.0942 29.1034 8.67997 24.0679C7.5841 21.7811 6.59734 19.7228 5.24614 18.5012C6.59734 17.2817 7.5841 15.2233 8.67997 12.9348C11.0947 7.89579 13.8321 2.18461 21.6066 2.02045C21.7178 2.01771 21.831 2.01718 21.9447 2.01718H120.057C120.17 2.01718 120.283 2.01718 120.397 2.02045C128.169 2.18461 130.906 7.89579 133.321 12.9348C134.417 15.2216 135.404 17.28 136.755 18.5012C135.404 19.721 134.417 21.7801 133.321 24.0679Z" fill="#040404" />
                                                </svg>
                                                <span className={`${randomData.fontName} fs-5`}
                                                    style={{ position: "relative", zIndex: 1, fontWeight: "700", lineHeight: "15px", fontSize: '17px', color: "#3E4095" }}>
                                                    {localNickname}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )}

                    {/* ════════════════════════════
                        EDIT (isEdit = true)
                    ════════════════════════════ */}
                    {isEdit && (
                        <div className={`text-center d-flex flex-column align-items-center justify-content-center flex-grow-1 ${isIOS ? "mt-2" : "mt-3"}`}>
                            {loading || !imageLoaded ? (
                                <CardSkeleton width={cardWidth()} />
                            ) : randomData ? (
                                <div
                                    className="shadow position-relative overflow-hidden rounded-4 mx-auto p-0 card-enter"
                                    style={{
                                        border: "1px solid black", width: cardWidth(),
                                        height: isSmallScreen ? "450px" : "500px",
                                        backgroundImage: `url(${randomData.CardBg})`,
                                        backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center",
                                        display: "flex", flexDirection: "column",
                                    }}
                                >
                                    {/* Frosted overlay */}
                                    <div style={{
                                        position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
                                        background: "rgba(255,255,255,0.86)", backdropFilter: "blur(5px)",
                                        WebkitBackdropFilter: "blur(5px)", zIndex: 1, willChange: "transform",
                                    }} />

                                    <div style={{
                                        position: "relative", zIndex: 2, flex: 1, overflowY: "auto", overflowX: "hidden",
                                        WebkitOverflowScrolling: "touch", padding: "0 14px 16px 14px",
                                    }}>
                                        {/* Avatar — pencil badge also opens bottom sheet in edit mode */}
                                        <div
                                            className="circle mt-3 position-relative d-flex justify-content-center align-items-center bg-white"
                                            style={{
                                                border: "3px solid #353435",
                                                width: isSmallScreen ? "100px" : "120px",
                                                height: isSmallScreen ? "100px" : "120px",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <div style={{ width: "100%", height: "100%", overflow: "hidden", borderRadius: "inherit" }}>
                                                <div style={{
                                                    width: "100%", height: "100%",
                                                    backgroundImage: `url(${localAvatar})`,
                                                    backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat",
                                                }} />
                                            </div>
                                            {/* Pencil badge */}
                                            <AvatarEditBadge />
                                        </div>

                                        {/* Nickname field */}
                                        <div style={{ marginBottom: "10px" }}>
                                            <p className="GTBold m-0 mb-1 text-start"
                                                style={{ fontSize: "14px", fontWeight: "700", color: "#373435", letterSpacing: "0.3px" }}>
                                                {t?.annoyCard?.nicknameLbl || "Nick name"}
                                            </p>
                                            <div className={shakingField === 'nickname' ? 'shake-animation' : ''}
                                                style={{
                                                    position: "relative", borderRadius: "12px",
                                                    border: "1.5px solid #000", background: "rgba(255,255,255,0.95)",
                                                    transition: "border-color 0.2s ease", overflow: "hidden",
                                                }}>
                                                <input
                                                    type="text" className="GTRegular"
                                                    value={editNickname}
                                                    onChange={(e) => {
                                                        if ([...e.target.value].length > EDIT_CHAR_LIMITS.nickname) triggerFieldShake('nickname');
                                                        else setEditNickname(e.target.value);
                                                    }}
                                                    onKeyDown={handleKeyDown}
                                                    placeholder={localNickname}
                                                    style={{
                                                        width: "100%", border: "none", outline: "none", background: "transparent",
                                                        padding: isSmallScreen ? "9px 48px 9px 12px" : "11px 52px 11px 14px",
                                                        fontSize: "16px", color: "#373435", fontFamily: "inherit",
                                                    }}
                                                    autoComplete="off"
                                                    enterKeyHint="done"
                                                />
                                                <span className="GTRegular"
                                                    style={{
                                                        position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)",
                                                        fontSize: "13px", color: [...editNickname].length >= EDIT_CHAR_LIMITS.nickname ? "#B40000" : "#000",
                                                        whiteSpace: "nowrap", fontWeight: "500", pointerEvents: "none",
                                                    }}>
                                                    {[...editNickname].length}/{EDIT_CHAR_LIMITS.nickname}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Answer fields */}
                                        {(localAnnoyans || []).map((item, i) => (
                                            <div key={i} style={{ marginBottom: i < (localAnnoyans.length - 1) ? "20px" : "8px" }}>
                                                <p className="GTBold m-0 mb-1 text-start"
                                                    style={{ fontSize: "14px", fontWeight: "700", color: "#373435", letterSpacing: "0.3px" }}>
                                                    <EditFieldLabel text={item.question} lanText={lanText} />
                                                </p>
                                                <div className={shakingField === `answer_${i}` ? 'shake-animation' : ''}
                                                    style={{
                                                        position: "relative", borderRadius: "12px",
                                                        border: "1.5px solid #000", background: "rgba(255,255,255,0.95)",
                                                        transition: "border-color 0.2s ease", overflow: "hidden",
                                                    }}>
                                                    <input
                                                        type="text" className="GTRegular"
                                                        value={editAnswers[i] || ''}
                                                        onChange={(e) => {
                                                            if ([...e.target.value].length > EDIT_CHAR_LIMITS.answer) triggerFieldShake(`answer_${i}`);
                                                            else { const next = [...editAnswers]; next[i] = e.target.value; setEditAnswers(next); }
                                                        }}
                                                        onKeyDown={handleKeyDown}
                                                        placeholder={item.answer || ''}
                                                        style={{
                                                            width: "100%", border: "none", outline: "none", background: "transparent",
                                                            padding: isSmallScreen ? "9px 52px 9px 12px" : "11px 56px 11px 14px",
                                                            fontSize: "16px", color: "#373435", fontFamily: "inherit",
                                                        }}
                                                        autoComplete="off"
                                                        enterKeyHint="done"
                                                    />
                                                    <span className="GTRegular"
                                                        style={{
                                                            position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)",
                                                            fontSize: "13px",
                                                            color: [...(editAnswers[i] || '')].length >= EDIT_CHAR_LIMITS.answer ? "#B40000" : "#000",
                                                            whiteSpace: "nowrap", fontWeight: "500", pointerEvents: "none",
                                                        }}>
                                                        {[...(editAnswers[i] || '')].length}/{EDIT_CHAR_LIMITS.answer}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )}

                    {/* ── Buttons ── */}
                    <div className='mx-auto mt-auto mb-2' style={{ width: "90%" }}>
                        {loading || !imageLoaded ? (
                            <div className="rounded-pill mx-auto shimmer-element"
                                style={{ width: "100%", height: "55px", transform: "scale(0.95)" }} />
                        ) : (
                            <>
                                <Button
                                    className="rounded-pill mx-auto GTMedium text-black border-0 mb-2 mt-2"
                                    style={{
                                        width: "100%", padding: "14px 1px", height: "55px",
                                        cursor: (!isUploading && !isCheckingConnection) ? 'pointer' : 'not-allowed',
                                        background: "white", transform: "scale(0.95)", opacity: 1,
                                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                    }}
                                    onClick={() => { if (!isUploading && !isCheckingConnection) handleEditToggle(); }}
                                    disabled={isUploading || isCheckingConnection}
                                >
                                    <span style={{ fontSize: "clamp(21px, 4.5vw, 27px)", lineHeight: 1, whiteSpace: "nowrap" }}>
                                        {isEdit ? (t?.common?.save || "Save") : (t?.common?.edit || "Edit")}
                                    </span>
                                </Button>

                                {!isEdit && (
                                    <Button
                                        className="rounded-pill mx-auto GTMedium text-white border-0"
                                        style={{
                                            width: "100%", padding: "14px 1px", height: "55px",
                                            cursor: (!isUploading && !isCheckingConnection) ? 'pointer' : 'not-allowed',
                                            background: "black", transform: "scale(0.95)", opacity: 1,
                                            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                        }}
                                        onClick={handleSendClick}
                                        disabled={isUploading || isCheckingConnection}
                                    >
                                        {isUploading || isCheckingConnection ? (
                                            <div className="custom-spinner" style={{ borderTopColor: "#FF207B" }} />
                                        ) : (
                                            <span style={{ fontSize: "clamp(21px, 4.5vw, 27px)", lineHeight: 1, whiteSpace: "nowrap" }}>
                                                {t?.common?.send || "Send"}
                                            </span>
                                        )}
                                    </Button>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <RotatePhonePopup excludeWhen={[isInputFocused]} />
            <LanguageDropdown />

            {/* ── Avatar bottom sheet ── */}
            <AvatarBottomSheet
                isOpen={avatarSheetOpen}
                onClose={() => setAvatarSheetOpen(false)}
                currentAvatar={localAvatar}
                onAvatarChange={handleAvatarChange}
                t={t}
            />

            <CompletePopup
                showSuccessModal={showSuccessModal}
                toggle={handleModalClose}
                data={originalData}
                username={username}
                category={category}
                style={{ zIndex: 10000 }}
            />
        </div>
    );
};

export default ShowCard;